import {
	Dimensions,
	FlatList,
	NativeScrollEvent,
	NativeSyntheticEvent,
	ScrollView,
	StyleSheet,
	Text,
	View,
	Image,
	Pressable,
	RefreshControl,
	SafeAreaView,
	Platform,
} from "react-native";
import dayjs from "dayjs";
import { Ionicons } from "@expo/vector-icons";
import { useTheme } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";
import { useQuery } from "react-query";
import useApi from "../../../hooks/useAPI";
import React, { useEffect, useState } from "react";
import { isic_get_card_microservice } from "../../../store/api";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";

const mcDonaldLogo = require("../../../../assets/images/camera/cap.png");
const Content = () => {
	const api = useApi();
	const { colors } = useTheme();
	const navigation = useNavigation();
	const [content, setContent] = useState([]);
	const user = useAppSelector(s => s.auth.subUser!);
	const [refreshing, setRefreshing] = useState(false);
	let pathUrl = `${isic_get_card_microservice}/users/announcements/documents/images/`;

	const { isLoading: servicesLoading, refetch: refetchContent } = useQuery(
		"content",
		() => api.announcements.getContent(user.id),
		{
			onSuccess: async res => {
				setContent(res.data);
			},
			onError: async (e: any) => {
				console.log("erro na get content");
			},
		}
	);
	return (
		<SafeAreaView style={styles.root}>
			<Pressable
				style={[
					styles.pressable,
					{ backgroundColor: colors.figmaBackgroundColor },
				]}
				onPress={navigation.goBack}
			>
				<Ionicons name="chevron-back" size={24} color={colors.pureWhite} />
				<View style={styles.title}>
					<Text style={[styles.text, { color: colors.pureWhite }]}>
						Comunicados
					</Text>
				</View>
			</Pressable>
			<ScrollView
				style={styles.scroll}
				refreshControl={
					<RefreshControl
						refreshing={refreshing}
						onRefresh={refetchContent}
						progressBackgroundColor="##F3F3F3"
						progressViewOffset={-20}
						colors={["rgb(8, 123, 245)"]}
						tintColor={"rgb(8, 123, 245)"}
					/>
				}
			>
				{content.map((item, index) => {
					return (
						<Pressable
							style={styles.contentBox}
							key={item.id}
							onPress={() => {
								navigation.navigate("SpecificContent", {
									info: item,
									navigation: navigation,
								});
							}}
						>
							<View style={styles.infosBox}>
								<Text style={styles.source}>{item.institution}</Text>
								<Text style={styles.titleContent}>{item.title}</Text>
								<Text style={styles.date}>
									{dayjs(item.created_at)
										.format("DD MMM, YYYY")
										.toLocaleUpperCase()}
								</Text>
							</View>
							<View style={styles.holdImage}>
								<Image
									source={{ uri: pathUrl + item.main_image_id }}
									style={styles.image}
								/>
							</View>
						</Pressable>
					);
				})}
			</ScrollView>
		</SafeAreaView>
	);
};
export default Content;

const styles = StyleSheet.create({
	root: { flex: 1, backgroundColor: "#0843F5" },
	scroll: {
		flex: 1,
		marginBottom: Platform.OS === "ios" ? 49 : 83,
		backgroundColor: "#fff",
	},
	pressable: {
		flexDirection: "row",
		alignItems: "center",
		backgroundColor: "#fff",
		padding: 20,
	},
	title: {
		alignItems: "center",
		marginLeft: -28,
		flex: 1,
	},
	text: {
    fontSize: 20,
    lineHeight: 26,
    fontFamily: "DmSans",
	},
	contentBox: {
		width: "100%",
		borderBottomWidth: 1,
		borderBottomColor: "rgba(171,171,171,0.5)",
		flexDirection: "row",
	},
	source: {
		color: "#ABABAB",
		fontSize: 12,
		fontFamily: "DmSans-bold",
	},
	titleContent: {
		color: "#3C351F",
		fontSize: 20,
		marginTop: 14,
		fontFamily: "DmSans-bold",
	},
	date: {
		color: "#ABABAB",
		fontSize: 12,
		marginTop: 22,
		fontFamily: "DmSans-bold",
		marginBottom: 19,
	},
	infosBox: {
		minWidth: 200,
		flex: 1,
		marginTop: 26,
		marginLeft: 16,
	},
	holdImage: {
		width: 140,
		height: 114,
		marginTop: 26,
		marginRight: 16,
		marginLeft: 12,
		marginBottom: 19,
	},
	image: {
		width: 140,
		height: 114,
		backgroundColor: "blue",
		borderRadius: 20,
	},
});
